export default "__VITE_ASSET__6dc059d2__"